import { z } from 'zod'

import { baseStructuredSchema } from '@/pages/instruments/new-instrument/schemas/shared/base-structured.schema'
import { contractTypeSchema } from '@/pages/instruments/new-instrument/schemas/shared/contract-type.schema'
import { knockdownInputLevelSchema } from '@/pages/instruments/new-instrument/schemas/shared/knockdown-input-level.schema'

export const rangeAccrualSchema = baseStructuredSchema.extend({
  instrument_type: z.literal('range-accrual'),

  coupon_rate_annual: z.number(),
  coupon_yearly_observations: z.number().min(1),
  contract_type: contractTypeSchema,

  knockdown_input_level: knockdownInputLevelSchema,
})

export type RangeAccrualSchemaType = z.infer<typeof rangeAccrualSchema>
